module.exports = __webpack_public_path__ + "img/e61e3444480c82301b4f8b2984c0738b.241d8453.png";